import { useEffect, useState } from 'react';
import BasicTable from '../../../components/table';
import { api } from '../../../services/axios';
import { AddModal } from './styles';

import AddIcon from '@mui/icons-material/Add';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { Button, CircularProgress, Divider, FormControl, FormControlLabel, FormLabel, InputAdornment, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material';
import { encode } from 'base-64';
import Modal from "react-modal";
import { ModalAlert } from '../../../components/modal';
import { ModalAlertDiv } from '../../../components/modal/style';
import { TableBar } from '../../../components/table/styles';

import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ModalDelete from '../../../components/modal/modalDelete';



const defaultForm = {
  name: '',
  address: '',
  city: '',
  country: '',
  language: 'es',
  chatUrl: '',
  inbTransfer: 'NAN',
  inbEndPoint: ''
}

const Transformer = () => {
  const url = "core/ajax/transformers"
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

  const headers = [
    { label: 'Id', value: 'IdCompany' },
    { label: 'Name', value: 'Company' },
    { label: 'Token', value: 'Token' },
    { label: 'CreateDate', value: 'CreateDate' },
    { label: 'Active', value: 'Active' },
    { label: 'Actions', value: 'Actions' },
  ]

  const [rows, setRows] = useState({ default: [], filter: [] })

  const [showModal, setShowModal] = useState(false)

  const [isValidate, setIsValidate] = useState(false)
  const [form, setForm] = useState(defaultForm);

  const [alert, setAlert] = useState({ msg: '', status: '' });
  const [showAlert, setShowAlert] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [id, setId] = useState();
  const [isCreate, setIsCreate] = useState(true);

  useEffect(() => {
    listUpdate()
  }, [])

  const listUpdate = () => {
    api.post(url, {
      type: 'list',
      authx: ''
    })
      .then(function (res) {
        setRows({
          default: res.data.map((e) => {
            return {
              ...e,
              IdCompany: Number(e.IdCompany),
            }
          }), filter: res.data.map((e) => {
            return {
              ...e,
              IdCompany: Number(e.IdCompany),
            }
          })
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const createGenerator = () => {
    api.post(url, {
      type: 'insert',
      Company: form.name,
      Address: form.address,
      City: form.city,
      Country: form.country,
      Language: form.language,
      ChatUrl: form.chatUrl,
      InbTransfer: form.inbTransfer,
      InbEndPoint: form.inbTransfer !== 'NAN' ? form.inbEndPoint : undefined,
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const updateForm = (row) => {
    setForm({
      name: row.Company,
      address: row.Address,
      city: row.City,
      country: row.Country,
      language: row.Language,
      chatUrl: row.ChatUrl,
      inbTransfer: row.InbTransfer,
      inbEndPoint: row.InbEndPoint !== 'NAN' ? row.InbEndPoint : ''
    })
    setIsCreate(false)
    setShowModal(true)
    setId(row.IdCompany)
  }

  const confirmUpdateForm = () => {
    api.post(url, {
      type: 'update',
      IdCompany: id,
      Company: form.name,
      Address: form.address,
      City: form.city,
      Country: form.country,
      Language: form.language,
      ChatUrl: form.chatUrl,
      InbTransfer: form.inbTransfer,
      InbEndPoint: form.inbTransfer !== 'NAN' ? form.inbEndPoint : undefined,
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const onDelete = (id) => {
    setId(id)
    setShowDelete(!showDelete)
    setAlert({ status: "go" })
  }

  const confirmDelete = () => {
      api.post(url, {
        type: 'delete',
        IdCompany: id,
        authx: ''
      })
        .then(function (res) {
          setAlert(res.data)
          listUpdate()
        })
        .catch(function (error) {
          setAlert({ msg: 'Ocorreu um erro', status: 'error' })
          console.log(error);
        });
  }


  const validation = () => {
    if (form.name === ''
      || form.city === ''
      || form.country === ''
      || form.language === ''
      || ((form.inbTransfer === 'SIP' && !emailRegex.test(form.inbEndPoint)) ||
        (form.inbTransfer === 'PHO' && (!isNaN(form.inbEndPoint) || form.inbEndPoint === '') && form.inbEndPoint.length < 11)) ? true : false) {
      setIsValidate(true)
      return false
    } else {
      return true
    }
  }

  const handleActive = (id, active) => {
      api.post(url, {
        type: 'activeTransformer',
        IdCompany: id,
        Active: active,
        authx: ''
      })
        .then(function (res) {
          setAlert(res.data)
          listUpdate()
        })
        .catch(function (error) {
          setAlert({ msg: 'Ocorreu um erro', status: 'error' })
          console.log(error);
        });
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxHeight: "90%",
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    }
  };


  const inputFilter = (e) => {
    const filter = rows.default.filter((row) => {
      return row.Company.toLowerCase().includes(e.target.value.toLowerCase()) ||
        row.Token.toLowerCase().includes(e.target.value.toLowerCase()) ||
        row.IdCompany.toString().includes(e.target.value) ||
        row.CreateDate.includes(e.target.value)
    });
    setRows({ ...rows, filter })
  }

  return (
    <TableBar>

      <h1>List Transformers</h1>
      <div className='buttons'>

        <TextField
          label="Search"
          variant="outlined"
          size='small'
          onChange={inputFilter}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchOutlinedIcon />
              </InputAdornment>
            ),
          }}
        />

        <Button startIcon={<AddIcon />} onClick={() => {
          setShowModal(!showModal)
          setIsCreate(true)
        }} variant="contained">Add</Button>
      </div>
      <BasicTable type={'tranformers'} headers={headers} rowsProps={rows.filter} updateForm={updateForm} onDelete={onDelete} handleActive={handleActive} />
      <Modal
        isOpen={showModal}
        onRequestClose={() => {
          setShowModal(false)
          setForm(defaultForm)
          setIsValidate(false)
        }}
        style={customStyles}
        ariaHideApp={false}>
        <AddModal>
          <h1>Transformers</h1>

          <Divider className='divider' variant="middle" />
          <TextField margin="dense" label="Name" variant="outlined"
            name='name'
            helperText={form.name === '' && isValidate ? "Incorrect entry." : ""}
            error={form.name === '' && isValidate}
            value={form.name}
            onChange={(e) => {
              setForm({
                ...form,
                name: e.target.value
              })
            }} />
          <TextField margin="dense" name='address' label="address" variant="outlined"
            value={form.address}
            onChange={(e) => {
              setForm({
                ...form,
                address: e.target.value
              })
            }} />
          <TextField margin="dense" label="City" variant="outlined"
            helperText={form.city === '' && isValidate ? "Incorrect entry." : ""}
            error={form.city === '' && isValidate}
            value={form.city}
            onChange={(e) => {
              setForm({
                ...form,
                city: e.target.value
              })
            }} />
          <TextField margin="dense" label="Country" variant="outlined"
            helperText={form.country === '' && isValidate ? "Incorrect entry." : ""}
            error={form.country === '' && isValidate}
            value={form.country}
            onChange={(e) => {
              setForm({
                ...form,
                country: e.target.value
              })
            }} />
          <FormControl sx={{ m: '8px 0 4px', minWidth: 120 }}>
            <InputLabel id="demo-simple-select-helper-label">Language</InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={form.language}
              label="Language"
              onChange={(e) => {
                setForm({
                  ...form,
                  language: e.target.value
                })
              }}
            >
              <MenuItem value={'es'}>ES</MenuItem>
              <MenuItem value={'en'}>EN</MenuItem>
              <MenuItem value={'pt'}>PT</MenuItem>
            </Select>
            {/* <FormhelperText>With label + helper text</FormhelperText> */}
          </FormControl>
          <TextField margin="dense" label="Chat Url" variant="outlined"
            value={form.chatUrl}
            onChange={(e) => {
              setForm({
                ...form,
                chatUrl: e.target.value
              })
            }} />

          <FormLabel id="demo-radio-buttons-group-label" sx={{ marginTop: '1rem' }}>Transfer Type *</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            defaultValue={'NAN'}
            // helperText={error.language ? "Incorrect entry." : ""}
            onChange={(e) => {
              e.target.value === 'NAN' ?
                setForm({
                  ...form,
                  inbTransfer: e.target.value,
                  inbEndPoint: ''
                }) :
                setForm({
                  ...form,
                  inbTransfer: e.target.value
                })
            }}
          >
            <FormControlLabel value="NAN" control={<Radio />} label="Nan" />
            <FormControlLabel value="PHO" control={<Radio />} label="Phone" />
            <FormControlLabel value="SIP" control={<Radio />} label="SIP" />
          </RadioGroup>

          {form.inbTransfer !== "NAN" &&
            <TextField margin="dense" label={form.inbTransfer === 'PHO' ? 'Phone' : 'SIP'} variant="outlined"
              error={form.inbEndPoint === '' && isValidate}
              value={form.inbEndPoint}
              onChange={(e) => {
                setForm({
                  ...form,
                  inbEndPoint: e.target.value
                })
              }} />}

          <Button sx={{ marginTop: '1rem' }} onClick={() => {
            if (validation()) {
              isCreate ? createGenerator() : confirmUpdateForm()
              setShowAlert(!showAlert)
            }
          }} variant="contained">{isCreate ? 'Create' : 'Update'}</Button>
        </AddModal>
      </Modal>

      {/* Modal Alert */}
      <ModalAlert showModal={showAlert} onClose={() => {
        setShowAlert(!showAlert)
        setAlert({ msg: '', status: undefined })
      }} onClickOutside={false}>
        {alert.status === undefined ?
          <ModalAlertDiv>
            <CircularProgress />
            <h1>Creating generator...</h1>
            <p>Please, wait...</p>
          </ModalAlertDiv>
          : alert.status === 'ok' ?
            <ModalAlertDiv>
              <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
              <h1>Success!</h1>

              <Button onClick={() => {
                setShowAlert(false)
              }} variant="contained">Ok</Button>
            </ModalAlertDiv>
            :
            <ModalAlertDiv>
              <h1>{alert.msg}</h1>
              <h3>:&#40;	</h3>
              <h3>{alert.msg}</h3>

            </ModalAlertDiv>}
      </ModalAlert>

      {/* Modal de delete */}
      <ModalDelete type={'transformer'} showDelete={showDelete} alert={alert} setShowDelete={setShowDelete} setAlert={setAlert} confirmDelete={confirmDelete} />

    </TableBar>
  );
}

export default Transformer;